/* eslint-disable no-unused-vars */
// import axios from 'axios'
import axios from '../../helpers/Axios'
import { Promise } from 'es6-promise'
import  router  from '../../router'

export const authmodule = {
	namespaced: true,
	state: {

		token: null,
		expiry: null,
		tokenRenewalTimeout: undefined
	},
	getters: {

		token: state => {
			return state.token;
		},

		expiry: state => {
			return state.expiry;
		}
	},

	actions: {

		updateToken({ commit, state, dispatch }) {
			var token = null;
			var expiresAt = null

			if (typeof window !== 'undefined') {
				token = JSON.parse(localStorage.getItem('access_token'));
				expiresAt = JSON.parse(localStorage.getItem('expires_in'));
			}

			if (new Date(expiresAt) - Date.now() > 0) {

				commit('setTokenExpiry', expiresAt);
				commit('setAccessToken', token);
				dispatch('scheduleRenewal');
			}
		},

		login({ commit, dispatch }, credentials) {
			var result = dispatch('logout').then(() => {
				return axios.post('/login', credentials);
			}).then(response => {

				if (typeof window !== 'undefined') {
					localStorage.setItem('access_token', JSON.stringify(response.data.access_token));
					localStorage.setItem('expires_in', JSON.stringify(response.data.expires_in));
				}
				commit('setAccessToken', response.data.access_token);
				commit('setTokenExpiry', response.data.expires_in);

				dispatch('scheduleRenewal');

				router.push({path: '/' });
				return Promise.resolve(true);

			}).catch(err => {

				console.log('Login failed', err);
				dispatch('logout');

				return Promise.resolve(false);
			});

			return Promise.resolve(result);
		},

		logout({ state, commit }) {

			if (typeof window !== 'undefined') {
				localStorage.setItem('access_token', null);
			}

			if (state.tokenRenewalTimeout != null) {
				window.clearTimeout(state.tokenRenewalTimeout);
				commit('setTokenRenewalTimeout', null);
			}

			commit('setAccessToken', null);
			commit('setTokenExpiry', null);

			router.push({path: '/login' });
		},

		renewToken({ state, commit, dispatch }) {

			const config = { headers: { 'Content-Type': 'application/json', 'Cache-Control': 'no-cache', Pragma: 'no-cache' } };

			return axios.get('/login', config).then(response => {

				if (typeof window !== 'undefined') {
					localStorage.setItem('access_token', JSON.stringify(response.data.access_token));
					localStorage.setItem('expires_in', JSON.stringify(response.data.expires_in));
				}

				commit('setAccessToken', response.data.access_token);
				commit('setTokenExpiry', response.data.expires_in);

				dispatch('scheduleRenewal');

			}).catch(err => {

				dispatch('logout');

				console.log('No longer authorized', err);

				Promise.reject(err.response);
			});
		},

		scheduleRenewal({ commit, dispatch }) {

			if (typeof window === 'undefined') return;

			var expiresAt = JSON.parse(localStorage.getItem('expires_in'));
			var delay = new Date(expiresAt) - Date.now();

			if (delay > 0) {

				var timer = setTimeout(function () {

					dispatch('renewToken');

				}, delay);

				commit('setTokenRenewalTimeout', timer);
			}
		}
	},
	mutations: {
		setTokenRenewalTimeout(state, timeout) {
			state.tokenRenewalTimeout = timeout;
		},

		setAccessToken(state, token) {
			state.token = token;
		},

		setTokenExpiry(state, expiry) {
			state.expiry = expiry;
		},

		setExpiryTime(state, expiry) {

		}
	}

}
